

export class ResetPasswordInputDto implements IResetPasswordInputDto {
    verificationCode!: string | undefined;
    password!: string | undefined;

    constructor(data?: IResetPasswordInputDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.verificationCode = _data["verificationCode"];
            this.password = _data["password"];
        }
    }

    static fromJS(data: any): ResetPasswordInputDto {
        data = typeof data === 'object' ? data : {};
        let result = new ResetPasswordInputDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["verificationCode"] = this.verificationCode;
        data["password"] = this.password;
        return data; 
    }
}

export interface IResetPasswordInputDto {
    verificationCode: string | undefined;
    password: string | undefined;
}

